import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=20ebb0ce&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=20ebb0ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ebb0ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20ebb0ce')) {
      api.createRecord('20ebb0ce', component.options)
    } else {
      api.reload('20ebb0ce', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=20ebb0ce&scoped=true&", function () {
      api.rerender('20ebb0ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-269j70cbrGQEr/JS/comp/CookieBox.vue"
export default component.exports